module.exports = __webpack_public_path__ + "static/media/bg-2-event-desktop-1920.ed529af3.svg";